// Attaches any module object to window under a stable global name.  Useful for vite / local dev
export function expose<T extends object>(globalName: string, mod: T, autoInit = true) {
    (window as any)[globalName] = mod;
    if (autoInit && typeof (mod as any).init === 'function') {
        (mod as any).init();
    }
}
